/**
 * @file   中和琴舫简介
 * @create macaiqi 2025/10/27
 * @update 
 */
import React, { useEffect, useState } from 'react';

import { queryAllChannel } from '../../service';

export default function Des({ setShow }) {
    const [channeldata, setChanneldata] = useState([]);

    useEffect(() => {
        queryAllChannel('CN').then(res => {
            setChanneldata(res?.records?.filter(a => {
                return a.channelNo === 'ZHQF'
            })?.[0])
        })
    }, [])
    return (
        <div className="shade zhqf-des ">
            <i
                className="close"
                onClick={() => {
                    setShow();
                }}></i>
            <div className="scroll">
                <div className="des" dangerouslySetInnerHTML={{ __html: channeldata?.description }} />
            </div>

        </div>
    )
}
